import React, { useEffect, useState } from "react";
import { collection, getDocs, addDoc } from "firebase/firestore";
import { db } from "../firebase";
import { Link } from "react-router-dom";
import Toast from "../components/Toast";
import "./EventList.css"; // Updated CSS file

export default function EventsList() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState({ show: false, type: "info", message: "" });

  // Fetch events from Firestore
  useEffect(() => {
    const fetchEvents = async () => {
      setLoading(true);
      try {
        const snap = await getDocs(collection(db, "events"));
        const arr = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        setEvents(arr);
      } catch (err) {
        console.error(err);
        setToast({ show: true, type: "error", message: "Failed to fetch events" });
        setTimeout(() => setToast({ show: false }), 2500);
      } finally {
        setLoading(false);
      }
    };
    fetchEvents();
  }, []);

  // Create sample events for demo
  const createSampleEvents = async () => {
    try {
      for (let i = 1; i <= 10; i++) {
        await addDoc(collection(db, "events"), {
          title: `Sample Event ${i}`,
          date: `2025-10-${i < 10 ? "0" + i : i}`,
          description: `This is sample event number ${i}. Join to learn and have fun!`,
          location: "Online / Demo Location",
          image: "https://source.unsplash.com/random/400x200?sig=" + i,
        });
      }
      setToast({ show: true, type: "success", message: "10 sample events added" });
      setTimeout(() => setToast({ show: false }), 2500);

      // Reload events
      setTimeout(async () => {
        const snap = await getDocs(collection(db, "events"));
        setEvents(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      }, 800);
    } catch (err) {
      console.error(err);
      setToast({ show: true, type: "error", message: "Failed to add sample events" });
      setTimeout(() => setToast({ show: false }), 2500);
    }
  };

  return (
    <div className="events-container-wrapper">
      <Toast show={toast.show} type={toast.type} message={toast.message} />

      <div className="events-header">
        <h1>Upcoming Events</h1>
        <div className="events-actions">
          <button onClick={createSampleEvents} className="btn">Load Sample Events</button>
          <Link to="/" className="btn">Back Home</Link>
        </div>
      </div>

      {loading ? (
        <div className="loading">Loading events...</div>
      ) : events.length === 0 ? (
        <div className="no-events">No events available yet.</div>
      ) : (
        <div className="events-grid">
          {events.map((ev) => (
            <div key={ev.id} className="event-card">
              <img src={ev.image || "https://via.placeholder.com/400x200"} alt={ev.title} />
              <h3>{ev.title}</h3>
              <p className="event-date">
                {ev.date} • {ev.location ?? "Location TBD"}
              </p>
              <p className="event-desc">
                {ev.description?.slice(0, 120)}
                {ev.description?.length > 120 ? "..." : ""}
              </p>
              <div className="event-buttons">
                <Link to={`/events/${ev.id}`} className="btn btn-detail">
                  Details
                </Link>
                <Link to={`/register/${ev.id}`} className="btn btn-register">
                  Register
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
